import {WaybillEventPresentation, WAYBILL_EVENT_PRESENTATIONS} from './ComWaybill.interfaces';

/**
 * Interface for the ComParcelsEvent entity (Com_Parcels_Event_DTO).
 * Represents complementary parcel event data associated with companies and dealers,
 * including additional view-specific fields.
 */
export interface ComParcelEvent {
  /** Unique ID for complementary event data */
  parcelEventComplementaryId?: number;

  /** ID of the parcel associated with the event */
  parcelEventComplementaryParcelId?: number;

  /** Reference parcel code */
  parcelEventComplementaryCode?: string;

  /** Waybill code associated with the parcel */
  parcelEventComplementaryWaybillCode?: string;

  /** Shipment code associated with the parcel */
  parcelEventComplementaryShipmentCode?: string;

  /** Complementary parameter name */
  parcelEventComplementaryName?: string;

  /** Category or type of complementary data */
  parcelEventComplementaryType?: string;

  /** Numeric value of the complementary data */
  parcelEventComplementaryValueNumber?: number;

  /** Text value of the complementary data */
  parcelEventComplementaryValueText?: string;

  /** Date value of the complementary data (ISO string, da OffsetDateTime) */
  parcelEventComplementaryValueDate?: string;

  /** CLOB value of the complementary data */
  parcelEventComplementaryValueClob?: string;

  /** Status of the complementary data */
  parcelEventComplementaryStatus?: string;

  /** Creation date of the complementary data (ISO string, da OffsetDateTime) */
  parcelEventComplementaryCreatedAt?: string;

  /** User that created the complementary data */
  parcelEventComplementaryCreatedBy?: string;

  /** Warehouse of origin of the event */
  parcelEventComplementaryWarehouseFrom?: string;

  /** Destination warehouse of the event */
  parcelEventComplementaryWarehouseTo?: string;

  // Additional fields for DTO

  /** Loading list code */
  loadingListCode?: string;

  /** Carrier code of the loading list */
  loadingListCarrierCode?: string;

  /** Default carrier group code */
  carrierCodeDefaultGroup?: string;
}

/**
 * Transcodifica dei nomi evento collo (parcelEventComplementaryName) nel relativo
 * modello di presentazione. Eredita le transcodifiche degli eventi bolla;
 * aggiungere qui le voci specifiche degli eventi collo.
 */
export const PARCEL_EVENT_PRESENTATIONS: { [name: string]: WaybillEventPresentation } = {
  ...WAYBILL_EVENT_PRESENTATIONS,
  DAMAGE: {label: 'Danneggiato', icon: 'fa-exclamation-triangle', variant: 'red'},
  SENT_TO_CLIENT: {label: 'DELIVERY Inviato al Cliente', icon: 'fa-share-square', variant: 'green'},
  SENT_REASON_CODE_TO_CLIENT: {label: 'REASON CODE inviata al Cliente', icon: 'fa-comment-dots', variant: 'purple'}
};
